import { backOff } from 'exponential-backoff';
import fetch from 'cross-fetch';
import { createClient as createClient$1, defaultExchanges, subscriptionExchange } from '@urql/core';
import { createClient } from 'graphql-ws';
import { pipe, subscribe } from 'wonka';

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DEFAULT_PAGE_FETCH_LIMIT = 50;
var DEFAULT_COLLECTION_PAGE_FETCH_LIMIT = 5;
var DEFAULT_MAX_ENTRIES = -1; // Always fetch complete index by default

var DEFAULT_MAX_ENTRIES_PER_COLLECTION = 5;
var X_NACELLE_SPACE_TOKEN = 'x-nacelle-space-token';
var X_NACELLE_PREVIEW_TOKEN = 'x-nacelle-preview-token';
var MISSING_SUB_PARAM_MSG = 'The params subscriptionToken && subscriptionEndpoint were not all provided';
var ENTRY_DEPTH_PARAM_WARNING_LIMIT = 5;
var QUERY_COMPLEXITY_ERROR_MESSAGE = 'Not enough complexity points available';
var QUERY_COMPLEXITY_ERROR_CODE = 'COMPLEXITY_ERROR';
var INTERNAL_SERVER_ERROR_CODE = 'INTERNAL_SERVER_ERROR';
var RETRY_STARTING_DELAY_IN_MS = 500;
var RETRY_MAX_DELAY_IN_MS = 5000;
var RETRY_NUMBER_OF_ATTEMPTS = 5;
var RETRY_TIME_MULTIPLE = 2;
var FIRST_FILTER_FALLBACK_VALUE = 1;
var FIRST_FILTER_OPTIMIZATION_VALUE = 2;
var EntryType;

(function (EntryType) {
  EntryType["PRODUCT"] = "product";
  EntryType["PRODUCT_CONTENT"] = "product-content";
  EntryType["VARIANT"] = "variant";
  EntryType["VARIANT_CONTENT"] = "variant-content";
  EntryType["CONTENT"] = "content";
  EntryType["CONTENT_COLLECTION"] = "content-collection";
  EntryType["PRODUCT_COLLECTION"] = "product-collection";
  EntryType["COLLECTION_CONTENT"] = "collection-content";
})(EntryType || (EntryType = {}));

var DataSourceName;

(function (DataSourceName) {
  DataSourceName["SHOPIFY"] = "shopify";
  DataSourceName["CONTENTFUL"] = "contentful";
  DataSourceName["SANITY"] = "sanity";
})(DataSourceName || (DataSourceName = {}));
/** Searchable fields for content */


var ContentSearchFields;

(function (ContentSearchFields) {
  ContentSearchFields["Handle"] = "HANDLE";
  ContentSearchFields["Title"] = "TITLE";
  ContentSearchFields["Type"] = "TYPE";
})(ContentSearchFields || (ContentSearchFields = {}));

var NavigationPropertyType;

(function (NavigationPropertyType) {
  NavigationPropertyType["Blog"] = "BLOG";
  NavigationPropertyType["Collection"] = "COLLECTION";
  NavigationPropertyType["External"] = "EXTERNAL";
  NavigationPropertyType["General"] = "GENERAL";
  NavigationPropertyType["Page"] = "PAGE";
  NavigationPropertyType["Product"] = "PRODUCT";
})(NavigationPropertyType || (NavigationPropertyType = {}));
/** Searchable fields for product collection */


var ProductCollectionSearchFields;

(function (ProductCollectionSearchFields) {
  ProductCollectionSearchFields["Handle"] = "HANDLE";
  ProductCollectionSearchFields["Title"] = "TITLE";
})(ProductCollectionSearchFields || (ProductCollectionSearchFields = {}));
/** Order by which to sort */


var ProductCollectionSortOrder;

(function (ProductCollectionSortOrder) {
  ProductCollectionSortOrder["Asc"] = "ASC";
  ProductCollectionSortOrder["Desc"] = "DESC";
})(ProductCollectionSortOrder || (ProductCollectionSortOrder = {}));
/** Searchable fields for product */


var ProductSearchFields;

(function (ProductSearchFields) {
  ProductSearchFields["Handle"] = "HANDLE";
  ProductSearchFields["Sku"] = "SKU";
  ProductSearchFields["Tags"] = "TAGS";
  ProductSearchFields["Title"] = "TITLE";
})(ProductSearchFields || (ProductSearchFields = {}));
/**
 * An enum with the common IETF language tags. We can
 * use a library for this in the future since there
 * are a lot and we don't want to manage this ourselves.
 * A quick search had a library, but it did not have types.
 * This list can be found here: https://gist.github.com/traysr/2001377
 */


var Locales;

(function (Locales) {
  Locales["en"] = "en";
  Locales["en_US"] = "en-US";
  Locales["en_GB"] = "en-GB";
  Locales["fr"] = "fr";
  Locales["de"] = "de";
  Locales["pl"] = "pl";
  Locales["nl"] = "nl";
  Locales["fi"] = "fi";
  Locales["sv"] = "sv";
  Locales["it"] = "it";
  Locales["es"] = "es";
  Locales["pt"] = "pt";
  Locales["ru"] = "ru";
  Locales["pt_BR"] = "pt-BR";
  Locales["es_MX"] = "es-MX";
  Locales["zh_CN"] = "zh-CN";
  Locales["zh_TW"] = "zh-TW";
  Locales["jp"] = "ja";
  Locales["ko"] = "ko";
})(Locales || (Locales = {}));

var ChunkFilterName;

(function (ChunkFilterName) {
  ChunkFilterName["NACELLE_ENTRY_ID"] = "nacelleEntryIds";
  ChunkFilterName["HANDLES"] = "handles";
})(ChunkFilterName || (ChunkFilterName = {}));

var metafield = "\n  id\n  key\n  namespace\n  value\n";
var contentCollection = "\n  createdAt\n  indexedAt\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  sourceEntryId\n  sourceId\n  tags\n  updatedAt\n";
var content = "\n  createdAt\n  fields\n  handle\n  indexedAt\n  locale\n  nacelleEntryId\n  published\n  sourceEntryId\n  sourceId\n  tags\n  title\n  type\n  updatedAt\n";
var media = "\n  altText\n  id\n  mimeType\n  src\n  thumbnailSrc\n  type\n";
var seo = "\n  title\n  description\n";
var collectionContent = "\n  collectionEntryId\n  createdAt\n  description\n  featuredMedia {\n    " + media + "\n  }\n  fields\n  handle\n  indexedAt\n  locale\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  # published\n  sourceEntryId\n  sourceId\n  title\n  updatedAt\n  seo {\n    " + seo + "\n  }\n";
var contentCollectionsQuery = "\nquery contentCollectionsQuery(\n  $filter: ContentCollectionFilterInput,\n  $maxReturnedEntriesPerCollection: Int\n) {\n  contentCollections(filter: $filter) {\n    " + contentCollection + "\n    entries(first: $maxReturnedEntriesPerCollection) {\n      " + content + "\n    }\n    content {\n      " + collectionContent + "\n    }\n  }\n}\n";
var contentCollectionEntriesQuery = "\nquery contentCollectionEntries(\n  $filter: ContentCollectionFilterInput,\n  $contentFirst: Int,\n  $contentAfter: String\n) {\n  contentCollections(filter: $filter) {\n    entries(first: $contentFirst, after: $contentAfter) {\n      " + content + "\n    }\n  }\n}\n";
var allContentCollectionsQuery = "\nquery allContentCollectionsQuery(\n  $filter: ContentCollectionFilterInput,\n  $maxReturnedEntriesPerCollection: Int\n) {\n  allContentCollections(filter: $filter) {\n    pageInfo {\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        " + contentCollection + "\n        contentConnection(first: $maxReturnedEntriesPerCollection) {\n          totalCount\n          pageInfo {\n            hasNextPage\n          }\n          edges {\n            cursor\n            node {\n              " + content + "\n            }\n          }\n        }\n        content {\n          " + collectionContent + "\n        }\n      }\n    }\n  }\n}\n";
var allContentCollectionEntriesQuery = "\nquery contentCollectionEntries(\n  $filter: ContentCollectionFilterInput,\n  $entriesFirst: Int,\n  $entriesAfter: String\n) {\n  allContentCollections(filter: $filter) {\n    edges {\n      node {\n        contentConnection(first: $entriesFirst, after: $entriesAfter) {\n          pageInfo {\n            hasNextPage\n          }\n          edges {\n            cursor\n            node {\n              " + content + "\n            }\n          }\n        }\n      }\n    }\n  }\n}\n";
var contentQuery = "\nquery content(\n  $filter: ContentFilterInput\n) {\n  content(filter: $filter) {\n    " + content + "\n  }\n}\n";
var allContentQuery = "\nquery allContent($filter: ContentFilterInput) {\n  allContent(filter: $filter) {\n    pageInfo {\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        " + content + "\n      }\n    }\n  }\n}\n";
var navigation = "\nfragment NavigationItem on NavigationGroupItem {\n\ttitle\n\ttype\n\turl\n\tmedia {\n\t\turl\n\t}\n\tproperties {\n\t\tkey\n\t\tvalue\n\t}\n}\n\nquery ($filter: NavigationFilterInput) {\n\tnavigation(filter: $filter) {\n\t\tgroupId\n\t\ttitle\n\t\tupdatedAt\n\t\tupdatedBy\n\t\titems {\n\t\t\t...NavigationItem\n\t\t\titems {\n\t\t\t\t...NavigationItem\n\t\t\t\titems {\n\t\t\t\t\t...NavigationItem\n\t\t\t\t\titems {\n\t\t\t\t\t\t...NavigationItem\n\t\t\t\t\t\titems {\n\t\t\t\t\t\t\t...NavigationItem\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n";
var option = "\n  name\n  values\n";
var productContent = "\n  createdAt\n  description\n  featuredMedia {\n    " + media + "\n  }\n  fields\n  handle\n  indexedAt\n  locale\n  media {\n    " + media + "\n  }\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  options {\n    " + option + "\n  }\n  productEntryId\n  published\n  seo {\n    " + seo + "\n  }\n  sourceEntryId\n  sourceId\n  title\n  updatedAt\n";
var variantContentFragment = "\n  createdAt\n  description\n  featuredMedia {\n    " + media + "\n  }\n  fields\n  indexedAt\n  locale\n  media {\n    " + media + "\n  }\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  productEntryId\n  productHandle\n  published\n  selectedOptions {\n    label\n    name\n    value\n  }\n  sourceEntryId\n  sourceId\n  swatchSrc\n  title\n  updatedAt\n  variantEntryId\n";
var productPriceBreaksFragment = "\n  metafields {\n    " + metafield + "\n  }\n  price\n  quantityMax\n  quantityMin\n";
var productPriceRulesFragment = "\n  availableTo\n  comparedAtPrice\n  handle\n  id\n  metafields {\n    " + metafield + "\n  }\n  price\n  priceBreaks {\n    " + productPriceBreaksFragment + "\n  }\n  priceCurrency\n  title\n";
var variantFragment = "\n  availableForSale\n  compareAtPrice\n  content {\n    " + variantContentFragment + "\n  }\n  createdAt\n  indexedAt\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  price\n  priceCurrency\n  priceRules {\n    " + productPriceRulesFragment + "\n  }\n  productEntryId\n  productHandle\n  quantityAvailable\n  sku\n  sourceEntryId\n  sourceId\n  updatedAt\n  weight\n  weightUnit\n";
var productFragmentSubset = "\n  availableForSale\n  createdAt\n  indexedAt\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  productType\n  sourceEntryId\n  sourceId\n  tags\n  updatedAt\n  vendor\n";
var product = "\n  " + productFragmentSubset + "\n  variants {\n    " + variantFragment + "\n  }\n  content {\n    " + productContent + "\n  }\n";
var productCollectionFragmentSubset = "\n  createdAt\n  indexedAt\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  sourceEntryId\n  sourceId\n  tags\n  updatedAt\n";
var productCollectionsQuery = "\nquery productCollections(\n  $filter: ProductCollectionFilterInput,\n  $maxReturnedEntriesPerCollection: Int\n) {\n  productCollections(filter: $filter) {\n    " + productCollectionFragmentSubset + "\n    content {\n      " + collectionContent + "\n    }\n    products(first: $maxReturnedEntriesPerCollection) {\n      " + product + "\n    }\n  }\n}\n";
var productCollectionEntriesQuery = "\nquery productCollectionEntries(\n  $filter: ProductCollectionFilterInput,\n  $entriesFirst: Int,\n  $entriesAfter: String\n) {\n  productCollections(filter: $filter) {\n    products(first: $entriesFirst, after: $entriesAfter) {\n      " + product + "\n    }\n  }\n}\n";
var allProductCollectionsQuery = "\nquery allProductCollections(\n  $filter: ProductCollectionFilterInput,\n  $maxReturnedEntriesPerCollection: Int\n) {\n  allProductCollections(filter: $filter) {\n    pageInfo {\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        " + productCollectionFragmentSubset + "\n        content {\n          " + collectionContent + "\n        }\n        productConnection(first: $maxReturnedEntriesPerCollection) {\n          totalCount\n          pageInfo {\n            hasNextPage\n          }\n          edges {\n            cursor\n            node {\n              " + product + "\n            }\n          }\n        }\n      }\n    }\n  }\n}\n";
var allProductCollectionEntriesQuery = "\nquery productCollectionEntries(\n  $filter: ProductCollectionFilterInput,\n  $entriesFirst: Int,\n  $entriesAfter: String\n) {\n  allProductCollections(filter: $filter) {\n    edges {\n      node {\n        productConnection(first: $entriesFirst, after: $entriesAfter) {\n          pageInfo {\n            hasNextPage\n          }\n          edges {\n            cursor\n            node {\n              " + product + "\n            }\n          }\n        }\n      }\n    }\n  }\n}\n";
var productsQuery = "\nquery products(\n  $filter: ProductFilterInput,\n) {\n  products(filter: $filter) {\n    " + productFragmentSubset + "\n    variants {\n      " + variantFragment + "\n    }\n    content {\n      " + productContent + "\n    }\n  }\n}\n";
var allProductsQuery = "\nquery allProducts($filter: ProductFilterInput) {\n  allProducts(filter: $filter) {\n    pageInfo {\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        " + productFragmentSubset + "\n        variants {\n          " + variantFragment + "\n        }\n        content {\n          " + productContent + "\n        }\n      }\n    }\n  }\n}\n";
var spaceQuery = "\nquery {\n  spaceProperties {\n\t\tproperties {\n\t\t\titems {\n\t\t\t\tkey\n\t\t\t\tvalue\n\t\t\t}\n\t\t\tnamespace\n\t\t}\n\t\tupdatedAt\n\t\tupdatedBy\n\t}\n}\n";
var productSubscription = "\nsubscription Subscription($productInventoryUpdatedFilter: InventoryItemsSubscriptionFilterInput) {\n  productInventoryUpdated (filter: $productInventoryUpdatedFilter) {\n    nacelleEntryId\n    entryType\n    availableForSale\n  }\n}";
var productVariantSubscription = "subscription Subscription($variantInventoryUpdatedFilter: InventoryItemsSubscriptionFilterInput) {\n    variantInventoryUpdated (filter: $variantInventoryUpdatedFilter) {\n      nacelleEntryId\n      entryType\n      availableForSale\n    }\n  }";
var productInventoryQuery = "\nquery ProductInventoryItems($filter: InventoryItemsQueryFilterInput) {\n  productInventoryItems(filter: $filter) {\n    nacelleEntryId\n    entryType\n    availableForSale\n  }\n} \n";
var productVariantInventoryQuery = "\nquery variantInventoryItems($filter: InventoryItemsQueryFilterInput) {\n  variantInventoryItems(filter: $filter) {\n    nacelleEntryId\n    entryType\n    availableForSale\n  }\n} \n";

function keepFetchingItems(fetchedItems, totalItems, maxReturnedEntries) {
  var lessItemsThanRequested = maxReturnedEntries ? maxReturnedEntries === -1 || totalItems.length < maxReturnedEntries : true;
  return fetchedItems.length > 0 && lessItemsThanRequested;
}

function keepFetchingItemsUsingNextPage(hasNextPage, totalItems, maxReturnedEntries) {
  var lessItemsThanRequested = typeof maxReturnedEntries === 'undefined' || maxReturnedEntries === -1 ? true : maxReturnedEntries !== 0 && totalItems.length < maxReturnedEntries;
  return Boolean(hasNextPage) && lessItemsThanRequested;
}

var isGraphQLError = function isGraphQLError(data) {
  return Boolean(data.errors && data.errors.length > 0);
};

var retryStatusCodes = [429, 500, 502, 503, 504 // Gateway Timeout
]; // https://www.apollographql.com/docs/apollo-server/data/errors/#error-codes

var retryApolloErrorCodes = [INTERNAL_SERVER_ERROR_CODE];
/**
 * @description Defines if a GraphQLResponseError meets the conditions to be retried
 * @param error GraphQLResponseError
 * @returns boolean
 */

function shouldRetryByResponseError(error) {
  var _error$extensions$cod, _error$extensions;

  var apolloErrorCode = (_error$extensions$cod = (_error$extensions = error.extensions) == null ? void 0 : _error$extensions.code) != null ? _error$extensions$cod : '';
  var isQueryComplexityError = apolloErrorCode === QUERY_COMPLEXITY_ERROR_CODE;

  if (isQueryComplexityError) {
    var _error$extensions$req, _error$extensions2, _error$extensions$thr, _error$extensions3, _error$extensions3$th;

    var requestedQueryCost = (_error$extensions$req = (_error$extensions2 = error.extensions) == null ? void 0 : _error$extensions2.requestedQueryCost) != null ? _error$extensions$req : 0;
    var totalCapacity = (_error$extensions$thr = (_error$extensions3 = error.extensions) == null ? void 0 : (_error$extensions3$th = _error$extensions3.throttleStatus) == null ? void 0 : _error$extensions3$th.totalCapacity) != null ? _error$extensions$thr : 0; // Only retry query complexity error when requested query cost is lower than total capacity
    // The idea is to give time to leaky bucket algorithm to drain necessary space to support requested query cost
    // We don't want to retry when requested cost is bigger than total capacity because it will fail on every attempt

    var shouldRetryComplexityError = totalCapacity > requestedQueryCost;
    return shouldRetryComplexityError;
  } // Retry based on selected apollo error codes


  return retryApolloErrorCodes.includes(apolloErrorCode);
}
/**
 * @description Some failed requests from Hail Frequency should be retried with
 * an exponential backoff pattern. Particularly if Hail Frequency threw some kind
 * of throttling or rate limiting error response. This function looks at the response
 * object and determines based on status code or error message for GraphQL errors, if
 * the request should be retried.
 *
 * @param response A isomorphic-unfetch response object
 * @param responseData An object that is the result of `await response.json()`
 * @returns a boolean indicating whether a request should be retried
 */


function shouldRetry(response, responseData) {
  if (retryStatusCodes.includes(response.status)) {
    return {
      shouldRetry: true,
      reason: "Request failed with status: " + response.status + " - " + response.statusText
    };
  } // GraphQL errors will be included in responseData


  if (isGraphQLError(responseData)) {
    var _responseData$errors$, _responseData$errors;

    var apolloErrorsToRetry = (_responseData$errors$ = (_responseData$errors = responseData.errors) == null ? void 0 : _responseData$errors.filter(shouldRetryByResponseError)) != null ? _responseData$errors$ : [];

    if (apolloErrorsToRetry.length > 0) {
      var _apolloErrorsToRetry$ = apolloErrorsToRetry[0],
          message = _apolloErrorsToRetry$.message,
          _apolloErrorsToRetry$2 = _apolloErrorsToRetry$.extensions,
          extensions = _apolloErrorsToRetry$2 === void 0 ? {} : _apolloErrorsToRetry$2;
      var reason = message + " - " + JSON.stringify(extensions);
      return {
        shouldRetry: true,
        reason: reason
      };
    }
  }

  return {
    shouldRetry: false
  };
}

var version = "1.7.10";
var _excluded$1 = ["headers"];
var backOffOptions = {
  delayFirstAttempt: true,
  jitter: 'full',
  numOfAttempts: RETRY_NUMBER_OF_ATTEMPTS,
  startingDelay: RETRY_STARTING_DELAY_IN_MS,
  maxDelay: RETRY_MAX_DELAY_IN_MS,
  timeMultiple: RETRY_TIME_MULTIPLE
};

var HttpClientFetch = /*#__PURE__*/function () {
  function HttpClientFetch(options) {
    this.options = void 0;
    var defaultOptions = {
      timeout: 240000
    };
    var defaultHeaders = {
      'Content-Type': 'application/json',
      'x-nacelle-sdk-version': version
    };

    var _ref = options || {},
        headers = _ref.headers,
        otherOptions = _objectWithoutPropertiesLoose(_ref, _excluded$1);

    this.options = _extends({
      headers: _extends({}, defaultHeaders, headers)
    }, defaultOptions, otherOptions);
  }

  var _proto = HttpClientFetch.prototype;

  _proto.get = /*#__PURE__*/function () {
    var _get = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
      var response, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(url, _extends({}, this.options, {
                method: 'GET'
              }));

            case 2:
              response = _context.sent;
              _context.next = 5;
              return response.json();

            case 5:
              data = _context.sent;
              return _context.abrupt("return", {
                headers: response.headers,
                status: response.status,
                statusText: response.statusText,
                data: data
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function get(_x) {
      return _get.apply(this, arguments);
    }

    return get;
  }();

  _proto.post = /*#__PURE__*/function () {
    var _post = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(url, data) {
      var _this = this;

      var attempt, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              attempt = 1;
              _context3.next = 3;
              return backOff( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                var innerResponse, responseData, retryResponse, errorMessage;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.prev = 0;
                        _context2.next = 3;
                        return fetch(url, _extends({}, _this.options, {
                          method: 'POST',
                          body: JSON.stringify(data)
                        }));

                      case 3:
                        innerResponse = _context2.sent;
                        _context2.next = 6;
                        return innerResponse.json();

                      case 6:
                        responseData = _context2.sent;
                        retryResponse = shouldRetry(innerResponse, responseData);

                        if (!retryResponse.shouldRetry) {
                          _context2.next = 10;
                          break;
                        }

                        throw Error(retryResponse.reason);

                      case 10:
                        return _context2.abrupt("return", _extends({}, innerResponse, {
                          responseData: responseData
                        }));

                      case 13:
                        _context2.prev = 13;
                        _context2.t0 = _context2["catch"](0);
                        errorMessage = "Failed POST request - Retry attempt " + attempt + " - " + _context2.t0;
                        console.warn(errorMessage);
                        attempt++;
                        throw _context2.t0;

                      case 19:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[0, 13]]);
              })), backOffOptions);

            case 3:
              response = _context3.sent;
              return _context3.abrupt("return", {
                headers: response.headers,
                status: response.status,
                statusText: response.statusText,
                data: response.responseData
              });

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function post(_x2, _x3) {
      return _post.apply(this, arguments);
    }

    return post;
  }();

  return HttpClientFetch;
}();
/**
 * @example
 * const httpEndpoint = convertWsToHttp('ws://localhost:4000/subscribe/spaces/ckuedwqim76883kswpwjdmtuz');
 *
 * @description Convert websocket endpoint to http
 *
 * - ws... -> http...
 * - wss... -> https...
 *
 * @param url {string} - A url
 *
 * @return returns a http(s) url
 */


function convertWsToHttp(url) {
  return url.replace(/(ws:\/\/|wss:\/\/){0,1}(.*)/, function (g1, g2, g3) {
    var prefix = '';

    if (g2 === 'wss://') {
      prefix = 'https://';
    } else {
      prefix = 'http://';
    }

    return prefix + g3;
  });
}
/**
 * @description Builds chunks with size chunkSize according to given parameters using best effort
 *
 * @param chunkSize number - Elements to be included on each chunk when possible
 * @param filterName ChunkFilterName - Defines the returned object property NacelleEntryIds or Handles
 * @param filterValues string[] - array of values to be separated in chunks
 * @param limit number - @defaults to DEFAULT_MAX_ENTRIES (-1) It re
 *    Represents total filter values to be returned among all chunks
 *    When set to -1 all "filterValues" will be included in the returned chunks
 *
 * @returns ChunkValues[]
 */


function buildChunks(chunkSize, filterName, filterValues, limit) {
  if (filterValues === void 0) {
    filterValues = [];
  }

  if (limit === void 0) {
    limit = DEFAULT_MAX_ENTRIES;
  }

  var chunkedParameters = [];
  var maxLength = limit < 0 || limit > filterValues.length ? filterValues.length : limit;

  for (var i = 0; i < maxLength; i += chunkSize) {
    var chunkLength = Math.min(i + chunkSize, maxLength);
    var chunkValues = filterValues.slice(i, chunkLength);
    var chunkValuesEntry = {
      filterName: filterName,
      values: chunkValues
    };
    chunkedParameters.push(chunkValuesEntry);
  }

  return chunkedParameters;
}

var handleGraphqlErrors = function handleGraphqlErrors(connectorParams, errors) {
  var errorMessage = 'Storefront GraphQL Error:';

  if (errors && errors.length > 0) {
    var _errors$reduce = errors.reduce(function (categories, error) {
      var _error$extensions;

      switch ((_error$extensions = error.extensions) == null ? void 0 : _error$extensions.code) {
        case 'UNAUTHENTICATED':
          categories.unauthenticated.push(error);
          break;

        case 'COMPLEXITY_ERROR':
          categories.complexityErrors.push(error);
          break;

        default:
          categories.otherErrors.push(error);
          break;
      }

      return categories;
    }, {
      unauthenticated: [],
      otherErrors: [],
      complexityErrors: []
    }),
        unauthenticated = _errors$reduce.unauthenticated,
        otherErrors = _errors$reduce.otherErrors,
        complexityErrors = _errors$reduce.complexityErrors;

    if (complexityErrors.length > 0) {
      var _complexityErrors$ = complexityErrors[0],
          message = _complexityErrors$.message,
          extensions = _complexityErrors$.extensions;
      throw new Error(message + "/" + JSON.stringify(extensions));
    }

    unauthenticated.forEach(function (error) {
      if (error.message.indexOf('x-nacelle-space-token') > -1 || error.message.indexOf('Token is invalid') > -1) {
        errorMessage += " The Storefront SDK client is trying to use an invalid Storefront API token, " + connectorParams.token + ", for " + connectorParams.endpoint + ".\nPlease verify that the client is initialized with the correct token parameter.'";
      }
    });
    otherErrors.forEach(function (error, index, arr) {
      var _ref = error.extensions || {},
          nacelleErrorId = _ref.nacelleErrorId,
          failedEntries = _ref.failedEntries;

      var displayIndex = arr.length > 1 ? " (" + (index + 1) + " of " + arr.length + ") " : '';
      var displayErrorId = nacelleErrorId ? " (Error Ref Id: " + nacelleErrorId + ")" : '';
      var stringifiedFailedEntries = failedEntries ? " - Error Details: " + JSON.stringify(failedEntries) : '';
      errorMessage += "" + displayIndex + error.message + displayErrorId + stringifiedFailedEntries;
    });

    if (connectorParams.debugMode) {
      console.info('Storefront SDK Debug: GraphQL Error Details', JSON.stringify(errors));
    }

    throw new Error(errorMessage);
  }
};
/**
 * @description Decide if an error needs to be thrown or if
 * @param errorMessage response error message
 * @param currentFirstFilter current value of "first" filter argument from request iteration
 * @returns
 */


var handleFailedResponse = function handleFailedResponse(currentFirstFilter, errorMessage) {
  var optimizedFirstFilter = FIRST_FILTER_FALLBACK_VALUE;
  var isQueryComplexityError = errorMessage == null ? void 0 : errorMessage.includes(QUERY_COMPLEXITY_ERROR_MESSAGE);

  if (isQueryComplexityError) {
    // NOTE(ENG-7019):
    //    It is possible to calculate an optimized value based on query complexity details (totalCapacity,
    //    currentQueryCost, currentCapacity) and fixed query value (SDK queries are statics and such value can be calculated)
    //    That solution highly couples the SDK retry logic with hf-graphql-api.
    //    It was decided to not have that dependency.
    //    New "first" filter optimized value will be calculated as follows:
    optimizedFirstFilter = Math.round(currentFirstFilter / FIRST_FILTER_OPTIMIZATION_VALUE);
  }

  var isQueryOptimized = currentFirstFilter === optimizedFirstFilter;
  var shouldThrowError = !isQueryComplexityError || isQueryOptimized;

  if (shouldThrowError) {
    throw new Error(errorMessage);
  }

  return optimizedFirstFilter;
};

function nodesFromEdges(edges) {
  return edges ? edges.map(function (_ref) {
    var node = _ref.node;
    return node;
  }) : [];
}

function lastEdgeCursor(edges) {
  return edges && edges.length > 0 ? edges[edges.length - 1].cursor : undefined;
}

function mapCollectionConnectionToArray(collection, connectionKey, placementKey) {
  var _extends2;

  var connection = collection[connectionKey];
  return _extends({}, collection, (_extends2 = {}, _extends2[placementKey] = nodesFromEdges(connection.edges), _extends2));
}

function checkDeprecatedQuery(params) {
  return Boolean(params && typeof params.startAfterEntryId !== 'undefined' && params.startAfterEntryId.length > 0);
}

var _excluded = ["cursor", "startAfterEntryId", "nacelleEntryIds", "handles", "locale", "maxReturnedEntries", "advancedOptions", "edgesToNodes"];

var StorefrontConnector = /*#__PURE__*/function () {
  function StorefrontConnector(params) {
    this.token = void 0;
    this.endpoint = void 0;
    this.previewToken = void 0;
    this.locale = void 0;
    this.httpClient = void 0;
    this.debugMode = void 0;
    this.endpoint = params.endpoint;
    this.token = params.token;
    this.previewToken = params.previewToken;
    this.locale = params.locale;
    this.debugMode = params.debugMode || false;

    if (this.debugMode) {
      console.info('credentials:', {
        endpoint: this.endpoint,
        token: this.token
      });
    }

    var headers = {};
    headers[X_NACELLE_SPACE_TOKEN] = this.token;

    if (this.previewToken) {
      // Set headers & query param required for preview mode.
      var currentEndpoint = new URL(this.endpoint);
      currentEndpoint.searchParams.append('preview', 'true');
      this.endpoint = currentEndpoint.toString();
      headers[X_NACELLE_PREVIEW_TOKEN] = this.previewToken;
    }

    this.httpClient = params.httpClient || new HttpClientFetch({
      headers: headers
    });
  } // TODO: clean up this method. too much branching logic


  var _proto = StorefrontConnector.prototype;

  _proto.request = /*#__PURE__*/function () {
    var _request = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
      var query, queryName, variables, data, response, graphqlResponse, queryResponseData, _queryResponseData;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              query = params.query, queryName = params.queryName, variables = params.variables;
              data = {
                query: query,
                variables: variables
              };

              if (this.debugMode) {
                console.info('storefront request', {
                  query: JSON.stringify(query),
                  variables: JSON.stringify(variables)
                });
              }

              _context.next = 6;
              return this.httpClient.post(this.endpoint, data);

            case 6:
              response = _context.sent;

              if (response) {
                _context.next = 9;
                break;
              }

              throw new Error("No valid response from " + queryName);

            case 9:
              graphqlResponse = response.data;

              if (isGraphQLError(graphqlResponse)) {
                handleGraphqlErrors(this, graphqlResponse.errors);
              }

              if (!graphqlResponse.data) {
                _context.next = 18;
                break;
              }

              if (!(queryName && graphqlResponse.data[queryName] !== 'undefined')) {
                _context.next = 15;
                break;
              }

              queryResponseData = graphqlResponse.data[queryName];
              return _context.abrupt("return", {
                success: true,
                data: queryResponseData
              });

            case 15:
              if (queryName) {
                _context.next = 18;
                break;
              }

              _queryResponseData = graphqlResponse.data;
              return _context.abrupt("return", {
                success: true,
                data: _queryResponseData
              });

            case 18:
              throw new Error("Response did not include " + queryName + ".\n        " + JSON.stringify(graphqlResponse, null, 2));

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", {
                success: false,
                error: _context.t0.message,
                data: null
              });

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 21]]);
    }));

    function request(_x) {
      return _request.apply(this, arguments);
    }

    return request;
  }();

  _proto.requestCollectionEntries = /*#__PURE__*/function () {
    var _requestCollectionEntries = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
      var params, query, queryName, key, cursor, collectionEntryId, handle, startAfterEntryId, _params$maxReturnedEn, maxReturnedEntries, locale, advancedOptions, _params$edgesToNodes, edgesToNodes, isDeprecatedQuery, entriesFirst, entriesAfter, allEntries, keepFetching, response, collection, entries, edges, _collection, _entries, pageInfo, collectionEdges, hasNextPage, items;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = options.params, query = options.query, queryName = options.queryName, key = options.key;
              cursor = params.cursor, collectionEntryId = params.collectionEntryId, handle = params.handle, startAfterEntryId = params.startAfterEntryId, _params$maxReturnedEn = params.maxReturnedEntries, maxReturnedEntries = _params$maxReturnedEn === void 0 ? DEFAULT_MAX_ENTRIES_PER_COLLECTION : _params$maxReturnedEn, locale = params.locale, advancedOptions = params.advancedOptions, _params$edgesToNodes = params.edgesToNodes, edgesToNodes = _params$edgesToNodes === void 0 ? true : _params$edgesToNodes;

              if (collectionEntryId && handle) {
                console.warn('You have supplied both a collectionEntryId and handle. This method will use collectionEntryId for querying.');
              }

              if (!(!collectionEntryId && !handle)) {
                _context2.next = 5;
                break;
              }

              throw new Error('You must provide either a collectionEntryId or handle.');

            case 5:
              isDeprecatedQuery = checkDeprecatedQuery(params);

              if (isDeprecatedQuery) {
                console.warn("You are using the parameter, startAfterEntryId, for a deprecated \nStorefront API query, " + queryName + ". This method and query will still return \nresults, but you will have better improved results and pagination support \nusing the parameter, cursor, instead.");
              }

              entriesFirst = Math.min.apply(Math, [(advancedOptions == null ? void 0 : advancedOptions.entriesPerPage) || DEFAULT_MAX_ENTRIES_PER_COLLECTION, maxReturnedEntries].filter(function (v) {
                return v > 0;
              }));
              entriesAfter = isDeprecatedQuery ? startAfterEntryId : cursor;
              allEntries = [];
              keepFetching = false;

            case 11:
              _context2.next = 13;
              return this.request({
                query: query,
                queryName: queryName,
                variables: _extends({
                  filter: _extends({}, collectionEntryId && {
                    nacelleEntryIds: [collectionEntryId]
                  }, !collectionEntryId && handle ? {
                    handles: [handle]
                  } : {}, locale ? {
                    locale: locale
                  } : {
                    locale: this.locale
                  }),
                  entriesFirst: entriesFirst
                }, entriesAfter && {
                  entriesAfter: entriesAfter
                })
              });

            case 13:
              response = _context2.sent;

              if (!(response.success && response.data)) {
                _context2.next = 18;
                break;
              }

              if (isDeprecatedQuery) {
                collection = response.data[0];
                entries = collection[key];

                if (entries) {
                  allEntries = allEntries.concat(entries);
                  entriesAfter = entries.length > 0 ? entries[entries.length - 1].nacelleEntryId : undefined;
                  keepFetching = keepFetchingItems(entries, allEntries, maxReturnedEntries);
                }
              } else {
                edges = response.data.edges;

                if (edges.length === 0) {
                  console.warn('No collections matching query');
                } else {
                  _collection = nodesFromEdges(edges)[0];
                  _entries = _collection[key];

                  if (_entries) {
                    pageInfo = _entries.pageInfo, collectionEdges = _entries.edges;
                    hasNextPage = pageInfo.hasNextPage;
                    items = edgesToNodes ? nodesFromEdges(collectionEdges) : collectionEdges;
                    allEntries = allEntries.concat(items);
                    entriesAfter = lastEdgeCursor(collectionEdges);
                    keepFetching = keepFetchingItemsUsingNextPage(hasNextPage, allEntries, maxReturnedEntries);
                  }
                }
              }

              _context2.next = 19;
              break;

            case 18:
              throw new Error(response.error);

            case 19:
              if (keepFetching) {
                _context2.next = 11;
                break;
              }

            case 20:
              return _context2.abrupt("return", allEntries);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function requestCollectionEntries(_x2) {
      return _requestCollectionEntries.apply(this, arguments);
    }

    return requestCollectionEntries;
  }();

  _proto.getEntriesFromResponse = function getEntriesFromResponse(responseData, isDeprecatedQuery, edgesToNodes) {
    if (isDeprecatedQuery) {
      return responseData;
    }

    var edges = responseData.edges;
    return edgesToNodes ? nodesFromEdges(edges) : edges;
  };

  _proto.calculateFilterFromChunk = function calculateFilterFromChunk(chunk, filterArgs) {
    var _ref;

    filterArgs.first = chunk.values.length;
    var parameterFilterValues = filterArgs.first > 0 ? (_ref = {}, _ref[chunk.filterName] = chunk.values, _ref) : {};
    return _extends({}, filterArgs, parameterFilterValues);
  };

  _proto.requestEntriesByFilter = /*#__PURE__*/function () {
    var _requestEntriesByFilter = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(requestEntriesByFilterParams) {
      var queryParams, limitParams, chunkParams, filterArgs, filterValues, query, queryName, edgesToNodes, isDeprecatedQuery, isCollectionQuery, maxReturnedEntries, maxReturnedEntriesPerCollection, chunkSize, chunkFilterName, allEntries, processedChunks, shouldKeepFetching, currentChunkSize, currentChunkParameters, chunkedParameters, targetEntriesLength, filter, response, entries, shouldKeepProcessingChunks, shouldKeepSearchingEntries, remainingFilterValues;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              queryParams = requestEntriesByFilterParams.queryParams, limitParams = requestEntriesByFilterParams.limitParams, chunkParams = requestEntriesByFilterParams.chunkParams, filterArgs = requestEntriesByFilterParams.filterArgs, filterValues = requestEntriesByFilterParams.filterValues;

              if (!(filterValues.length === 0)) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", []);

            case 3:
              query = queryParams.query, queryName = queryParams.queryName, edgesToNodes = queryParams.edgesToNodes, isDeprecatedQuery = queryParams.isDeprecatedQuery, isCollectionQuery = queryParams.isCollectionQuery;
              maxReturnedEntries = limitParams.maxReturnedEntries, maxReturnedEntriesPerCollection = limitParams.maxReturnedEntriesPerCollection;
              chunkSize = chunkParams.chunkSize, chunkFilterName = chunkParams.chunkFilterName;
              allEntries = [];
              processedChunks = 0;
              shouldKeepFetching = true;
              currentChunkSize = chunkSize; // Initialize chunks parameters with received params setup

              chunkedParameters = buildChunks(currentChunkSize, chunkFilterName, filterValues, maxReturnedEntries); // Number of entries that we are looking to retrieve

              targetEntriesLength = maxReturnedEntries < 0 || maxReturnedEntries > filterValues.length ? filterValues.length : maxReturnedEntries;

            case 12:
              currentChunkParameters = chunkedParameters[processedChunks];
              filter = this.calculateFilterFromChunk(currentChunkParameters, filterArgs);
              _context3.next = 16;
              return this.request({
                query: query,
                queryName: queryName,
                variables: _extends({
                  filter: filter
                }, isCollectionQuery && {
                  maxReturnedEntriesPerCollection: maxReturnedEntriesPerCollection
                })
              });

            case 16:
              response = _context3.sent;

              if (response.success && response.data) {
                entries = this.getEntriesFromResponse(response.data, isDeprecatedQuery, edgesToNodes);
                allEntries = allEntries.concat(entries); // Should continue with iteration?

                processedChunks++;
                shouldKeepProcessingChunks = chunkedParameters.length > processedChunks;
                shouldKeepSearchingEntries = allEntries.length < targetEntriesLength;
                shouldKeepFetching = shouldKeepProcessingChunks && shouldKeepSearchingEntries;
              } else {
                currentChunkSize = handleFailedResponse(currentChunkSize, response.error); // Reset Chunks Processed Counter

                processedChunks = 0; // Calculate remaining filterValues to process

                remainingFilterValues = filterValues.slice(allEntries.length); // Build new chunk parameters based on the remaining filter values and the new chunkSize

                chunkedParameters = buildChunks(currentChunkSize, chunkFilterName, remainingFilterValues, maxReturnedEntries);
              }

            case 18:
              if (shouldKeepFetching) {
                _context3.next = 12;
                break;
              }

            case 19:
              return _context3.abrupt("return", allEntries);

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function requestEntriesByFilter(_x3) {
      return _requestEntriesByFilter.apply(this, arguments);
    }

    return requestEntriesByFilter;
  }();

  _proto.requestEntriesByNacelleEntryIds = /*#__PURE__*/function () {
    var _requestEntriesByNacelleEntryIds = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(queryParams, limitParams, filterArgs, chunkSize, nacelleEntryIds) {
      var chunkParamsByIds, requestEntriesByNacelleEntryIdsParams;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              chunkParamsByIds = {
                chunkSize: chunkSize,
                chunkFilterName: ChunkFilterName.NACELLE_ENTRY_ID
              };
              requestEntriesByNacelleEntryIdsParams = {
                queryParams: queryParams,
                limitParams: limitParams,
                filterArgs: filterArgs,
                chunkParams: chunkParamsByIds,
                filterValues: nacelleEntryIds || []
              };
              return _context4.abrupt("return", this.requestEntriesByFilter(requestEntriesByNacelleEntryIdsParams));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function requestEntriesByNacelleEntryIds(_x4, _x5, _x6, _x7, _x8) {
      return _requestEntriesByNacelleEntryIds.apply(this, arguments);
    }

    return requestEntriesByNacelleEntryIds;
  }();

  _proto.requestEntriesByHandles = /*#__PURE__*/function () {
    var _requestEntriesByHandles = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(queryParams, limitParams, filterArgs, chunkSize, handles) {
      var chunkParamsByHandles, requestEntriesByHandlesParams;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              chunkParamsByHandles = {
                chunkSize: chunkSize,
                chunkFilterName: ChunkFilterName.HANDLES
              };
              requestEntriesByHandlesParams = {
                queryParams: queryParams,
                limitParams: limitParams,
                filterArgs: filterArgs,
                chunkParams: chunkParamsByHandles,
                filterValues: handles || []
              };
              return _context5.abrupt("return", this.requestEntriesByFilter(requestEntriesByHandlesParams));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function requestEntriesByHandles(_x9, _x10, _x11, _x12, _x13) {
      return _requestEntriesByHandles.apply(this, arguments);
    }

    return requestEntriesByHandles;
  }();

  _proto.requestEntriesByPagination = /*#__PURE__*/function () {
    var _requestEntriesByPagination = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(queryParams, limitParams, filterArgs) {
      var query, queryName, edgesToNodes, isDeprecatedQuery, isCollectionQuery, maxReturnedEntries, maxReturnedEntriesPerCollection, nextAfter, keepFetching, allEntries, variables, response, entries, _response$data, pageInfo, edges, hasNextPage, _entries2;

      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              query = queryParams.query, queryName = queryParams.queryName, edgesToNodes = queryParams.edgesToNodes, isDeprecatedQuery = queryParams.isDeprecatedQuery, isCollectionQuery = queryParams.isCollectionQuery;
              maxReturnedEntries = limitParams.maxReturnedEntries, maxReturnedEntriesPerCollection = limitParams.maxReturnedEntriesPerCollection;
              nextAfter = filterArgs.after;
              keepFetching = true;
              allEntries = [];

            case 5:
              variables = _extends({
                filter: _extends({}, filterArgs, {
                  after: nextAfter
                })
              }, isCollectionQuery && {
                maxReturnedEntriesPerCollection: maxReturnedEntriesPerCollection
              });
              _context6.next = 8;
              return this.request({
                query: query,
                queryName: queryName,
                variables: variables
              });

            case 8:
              response = _context6.sent;

              if (response.success && response.data) {
                if (isDeprecatedQuery) {
                  entries = response.data;
                  allEntries = allEntries.concat(entries);
                  nextAfter = entries.length > 0 ? entries[entries.length - 1].nacelleEntryId : undefined;
                  keepFetching = keepFetchingItems(entries, allEntries, maxReturnedEntries);
                } else {
                  _response$data = response.data, pageInfo = _response$data.pageInfo, edges = _response$data.edges;
                  hasNextPage = pageInfo.hasNextPage;
                  _entries2 = edgesToNodes ? nodesFromEdges(edges) : edges;
                  allEntries = allEntries.concat(_entries2);
                  nextAfter = lastEdgeCursor(edges);
                  keepFetching = keepFetchingItemsUsingNextPage(hasNextPage, allEntries, maxReturnedEntries);
                }
              } else {
                filterArgs.first = handleFailedResponse(filterArgs.first, response.error);
              }

            case 10:
              if (keepFetching) {
                _context6.next = 5;
                break;
              }

            case 11:
              return _context6.abrupt("return", maxReturnedEntries > -1 ? allEntries.slice(0, maxReturnedEntries) : allEntries);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function requestEntriesByPagination(_x14, _x15, _x16) {
      return _requestEntriesByPagination.apply(this, arguments);
    }

    return requestEntriesByPagination;
  }()
  /**
   * @description This is a helper method for fetching either pages of entries of
   * a given entry type or fetching entries by id or handles.
   * @param query The query to perform
   * @param queryName The query operation name
   * @param params method parameters that will be transformed into Storefront GraphQL
   * query variables.
   * @returns A promise for an array of type T
   */
  ;

  _proto.requestEntries = /*#__PURE__*/function () {
    var _requestEntries = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(query, queryName, params) {
      var _advancedOptions$entr;

      var _ref2, cursor, startAfterEntryId, nacelleEntryIds, handles, locale, _ref2$maxReturnedEntr, maxReturnedEntries, advancedOptions, _ref2$edgesToNodes, edgesToNodes, addlParams, _ref3, _ref3$maxReturnedEntr, maxReturnedEntriesPerCollection, isCollectionQuery, isDeprecatedQuery, nextAfter, first, filterArgs, chunkSize, queryParams, limitParams;

      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _ref2 = params || {}, cursor = _ref2.cursor, startAfterEntryId = _ref2.startAfterEntryId, nacelleEntryIds = _ref2.nacelleEntryIds, handles = _ref2.handles, locale = _ref2.locale, _ref2$maxReturnedEntr = _ref2.maxReturnedEntries, maxReturnedEntries = _ref2$maxReturnedEntr === void 0 ? DEFAULT_MAX_ENTRIES : _ref2$maxReturnedEntr, advancedOptions = _ref2.advancedOptions, _ref2$edgesToNodes = _ref2.edgesToNodes, edgesToNodes = _ref2$edgesToNodes === void 0 ? true : _ref2$edgesToNodes, addlParams = _objectWithoutPropertiesLoose(_ref2, _excluded);
              _ref3 = params || {}, _ref3$maxReturnedEntr = _ref3.maxReturnedEntriesPerCollection, maxReturnedEntriesPerCollection = _ref3$maxReturnedEntr === void 0 ? DEFAULT_MAX_ENTRIES_PER_COLLECTION : _ref3$maxReturnedEntr;
              isCollectionQuery = ['productCollections', 'contentCollections', 'allProductCollections', 'allContentCollections'].includes(queryName);
              isDeprecatedQuery = checkDeprecatedQuery(params);

              if (isDeprecatedQuery) {
                console.warn("You are using the parameter, startAfterEntryId, for a deprecated \nStorefront API query, " + queryName + ". This method and query will still return \nresults, but you will have better improved results and pagination support \nusing the parameter, cursor, instead.");
              }

              if (addlParams.maxReturnedEntriesPerCollection) {
                delete addlParams.maxReturnedEntriesPerCollection;
              }

              nextAfter = isDeprecatedQuery ? startAfterEntryId : cursor;
              first = Math.min.apply(Math, [(advancedOptions == null ? void 0 : advancedOptions.entriesPerPage) || DEFAULT_PAGE_FETCH_LIMIT, maxReturnedEntries].filter(function (v) {
                return v > 0;
              }));
              filterArgs = _extends({
                first: first,
                after: nextAfter
              }, locale ? {
                locale: locale
              } : {
                locale: this.locale
              }, addlParams);
              chunkSize = (_advancedOptions$entr = advancedOptions == null ? void 0 : advancedOptions.entriesPerPage) != null ? _advancedOptions$entr : DEFAULT_PAGE_FETCH_LIMIT;
              queryParams = {
                query: query,
                queryName: queryName,
                isDeprecatedQuery: isDeprecatedQuery,
                isCollectionQuery: isCollectionQuery,
                edgesToNodes: edgesToNodes
              };
              limitParams = {
                maxReturnedEntries: maxReturnedEntries,
                maxReturnedEntriesPerCollection: maxReturnedEntriesPerCollection
              };

              if (nacelleEntryIds && handles) {
                console.warn('You have supplied both a nacelleEntryIds and handles. This method will use nacelleEntryIds for querying.');
              }

              if (!nacelleEntryIds) {
                _context7.next = 15;
                break;
              }

              return _context7.abrupt("return", this.requestEntriesByNacelleEntryIds(queryParams, limitParams, filterArgs, chunkSize, nacelleEntryIds));

            case 15:
              if (!handles) {
                _context7.next = 17;
                break;
              }

              return _context7.abrupt("return", this.requestEntriesByHandles(queryParams, limitParams, filterArgs, chunkSize, handles));

            case 17:
              return _context7.abrupt("return", this.requestEntriesByPagination(queryParams, limitParams, filterArgs));

            case 18:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function requestEntries(_x17, _x18, _x19) {
      return _requestEntries.apply(this, arguments);
    }

    return requestEntries;
  }();

  _proto.products = /*#__PURE__*/function () {
    var _products = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(params) {
      var isDeprecatedQuery, query, queryName;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              isDeprecatedQuery = checkDeprecatedQuery(params);
              query = isDeprecatedQuery ? productsQuery : allProductsQuery;
              queryName = isDeprecatedQuery ? 'products' : 'allProducts';
              return _context8.abrupt("return", this.requestEntries(query, queryName, params));

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function products(_x20) {
      return _products.apply(this, arguments);
    }

    return products;
  }();

  _proto.productCollections = /*#__PURE__*/function () {
    var _productCollections = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(params) {
      var _ref4, _ref4$edgesToNodes, edgesToNodes, _ref4$advancedOptions, advancedOptions, isDeprecatedQuery, query, queryName, collections;

      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _ref4 = params || {}, _ref4$edgesToNodes = _ref4.edgesToNodes, edgesToNodes = _ref4$edgesToNodes === void 0 ? true : _ref4$edgesToNodes, _ref4$advancedOptions = _ref4.advancedOptions, advancedOptions = _ref4$advancedOptions === void 0 ? {} : _ref4$advancedOptions;
              isDeprecatedQuery = checkDeprecatedQuery(params);
              query = isDeprecatedQuery ? productCollectionsQuery : allProductCollectionsQuery;
              queryName = isDeprecatedQuery ? 'productCollections' : 'allProductCollections';

              if (typeof advancedOptions.entriesPerPage === 'undefined') {
                advancedOptions.entriesPerPage = DEFAULT_COLLECTION_PAGE_FETCH_LIMIT;
              }

              if (advancedOptions.entriesPerPage > 100) {
                console.warn('You have set the `entriesPerPage` option to a high value. We recommended keeping this value small for collections to avoid issues.');
              }

              _context9.next = 8;
              return this.requestEntries(query, queryName, _extends({}, params, {
                advancedOptions: advancedOptions
              }));

            case 8:
              collections = _context9.sent;

              if (!isDeprecatedQuery) {
                _context9.next = 11;
                break;
              }

              return _context9.abrupt("return", collections);

            case 11:
              if (!edgesToNodes) {
                _context9.next = 13;
                break;
              }

              return _context9.abrupt("return", collections.map(function (collection) {
                return mapCollectionConnectionToArray(collection, 'productConnection', 'products');
              }));

            case 13:
              return _context9.abrupt("return", collections.map(function (edge) {
                return _extends({}, edge, {
                  node: mapCollectionConnectionToArray(edge.node, 'productConnection', 'products')
                });
              }));

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function productCollections(_x21) {
      return _productCollections.apply(this, arguments);
    }

    return productCollections;
  }();

  _proto.content = /*#__PURE__*/function () {
    var _content = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(params) {
      var _params$entryDepth;

      var isDeprecatedQuery, query, queryName;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              isDeprecatedQuery = checkDeprecatedQuery(params);
              query = isDeprecatedQuery ? contentQuery : allContentQuery;

              if (Number((_params$entryDepth = params == null ? void 0 : params.entryDepth) != null ? _params$entryDepth : 0) > ENTRY_DEPTH_PARAM_WARNING_LIMIT) {
                console.warn("SDK performance could be affected using \"entryDepth\" parameter greater than " + ENTRY_DEPTH_PARAM_WARNING_LIMIT + ". Consider using a lower value when possible");
              }

              queryName = isDeprecatedQuery ? 'content' : 'allContent';
              return _context10.abrupt("return", this.requestEntries(query, queryName, params));

            case 5:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function content(_x22) {
      return _content.apply(this, arguments);
    }

    return content;
  }();

  _proto.contentCollections = /*#__PURE__*/function () {
    var _contentCollections = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(params) {
      var _ref5, _ref5$edgesToNodes, edgesToNodes, isDeprecatedQuery, query, queryName, collections;

      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _ref5 = params || {}, _ref5$edgesToNodes = _ref5.edgesToNodes, edgesToNodes = _ref5$edgesToNodes === void 0 ? true : _ref5$edgesToNodes;
              isDeprecatedQuery = checkDeprecatedQuery(params);
              query = isDeprecatedQuery ? contentCollectionsQuery : allContentCollectionsQuery;
              queryName = isDeprecatedQuery ? 'contentCollections' : 'allContentCollections';
              _context11.next = 6;
              return this.requestEntries(query, queryName, params);

            case 6:
              collections = _context11.sent;

              if (!isDeprecatedQuery) {
                _context11.next = 9;
                break;
              }

              return _context11.abrupt("return", collections);

            case 9:
              if (!edgesToNodes) {
                _context11.next = 11;
                break;
              }

              return _context11.abrupt("return", collections.map(function (collection) {
                return mapCollectionConnectionToArray(collection, 'contentConnection', 'entries');
              }));

            case 11:
              return _context11.abrupt("return", collections.map(function (edge) {
                return _extends({}, edge, {
                  node: mapCollectionConnectionToArray(edge.node, 'contentConnection', 'entries')
                });
              }));

            case 12:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function contentCollections(_x23) {
      return _contentCollections.apply(this, arguments);
    }

    return contentCollections;
  }();

  _proto.navigation = /*#__PURE__*/function () {
    var _navigation2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(params) {
      var requestParams, response;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              requestParams = {
                query: navigation,
                queryName: 'navigation'
              };

              if (params) {
                requestParams.variables = {
                  filter: params
                };
              }

              _context12.next = 4;
              return this.request(requestParams);

            case 4:
              response = _context12.sent;

              if (!(response.success && response.data)) {
                _context12.next = 7;
                break;
              }

              return _context12.abrupt("return", response.data);

            case 7:
              throw new Error(response.error);

            case 8:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function navigation$1(_x24) {
      return _navigation2.apply(this, arguments);
    }

    return navigation$1;
  }();

  _proto.query = /*#__PURE__*/function () {
    var _query = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(params) {
      var query, variables, response;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              query = params.query, variables = params.variables;
              _context13.next = 3;
              return this.request({
                query: query,
                variables: variables
              });

            case 3:
              response = _context13.sent;

              if (!(response.success && response.data)) {
                _context13.next = 6;
                break;
              }

              return _context13.abrupt("return", response.data);

            case 6:
              throw new Error(response.error);

            case 7:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function query(_x25) {
      return _query.apply(this, arguments);
    }

    return query;
  }();

  _proto.setConfig = function setConfig(setConfigParams) {
    var _this$httpClient$opti;

    if (!((_this$httpClient$opti = this.httpClient.options) != null && _this$httpClient$opti.headers)) {
      throw new Error('[setConfig]: http client is missing headers.');
    }

    var currentEndpoint = new URL(this.endpoint);
    var previewTokenHeader = X_NACELLE_PREVIEW_TOKEN;

    if (setConfigParams.previewToken) {
      this.previewToken = setConfigParams.previewToken;
      currentEndpoint.searchParams.set('preview', 'true');
      this.httpClient.options.headers[previewTokenHeader] = this.previewToken;
    } else {
      this.previewToken = undefined;
      currentEndpoint.searchParams["delete"]('preview');
      delete this.httpClient.options.headers[previewTokenHeader];
    }

    this.endpoint = currentEndpoint.toString();
    return {
      endpoint: this.endpoint,
      previewToken: this.previewToken
    };
  };

  _proto.spaceProperties = /*#__PURE__*/function () {
    var _spaceProperties2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
      var response;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.request({
                query: spaceQuery,
                queryName: 'spaceProperties'
              });

            case 2:
              response = _context14.sent;

              if (!(response.success && response.data)) {
                _context14.next = 5;
                break;
              }

              return _context14.abrupt("return", response.data);

            case 5:
              throw new Error(response.error);

            case 6:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function spaceProperties() {
      return _spaceProperties2.apply(this, arguments);
    }

    return spaceProperties;
  }();

  _proto.productCollectionEntries = /*#__PURE__*/function () {
    var _productCollectionEntries = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(params) {
      var isDeprecatedQuery, query, queryName, key;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              isDeprecatedQuery = checkDeprecatedQuery(params);
              query = isDeprecatedQuery ? productCollectionEntriesQuery : allProductCollectionEntriesQuery;
              queryName = isDeprecatedQuery ? 'productCollections' : 'allProductCollections';
              key = isDeprecatedQuery ? 'products' : 'productConnection';
              return _context15.abrupt("return", this.requestCollectionEntries({
                query: query,
                queryName: queryName,
                key: key,
                params: params
              }));

            case 5:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    function productCollectionEntries(_x26) {
      return _productCollectionEntries.apply(this, arguments);
    }

    return productCollectionEntries;
  }();

  _proto.contentCollectionEntries = /*#__PURE__*/function () {
    var _contentCollectionEntries = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(params) {
      var isDeprecatedQuery, query, queryName, key;
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              isDeprecatedQuery = checkDeprecatedQuery(params);
              query = isDeprecatedQuery ? contentCollectionEntriesQuery : allContentCollectionEntriesQuery;
              queryName = isDeprecatedQuery ? 'contentCollections' : 'allContentCollections';
              key = isDeprecatedQuery ? 'entries' : 'contentConnection';
              return _context16.abrupt("return", this.requestCollectionEntries({
                query: query,
                queryName: queryName,
                key: key,
                params: params
              }));

            case 5:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this);
    }));

    function contentCollectionEntries(_x27) {
      return _contentCollectionEntries.apply(this, arguments);
    }

    return contentCollectionEntries;
  }();

  return StorefrontConnector;
}();

var SubscriptionConnector = function SubscriptionConnector(params) {
  var _this = this;

  this.token = void 0;
  this.endpoint = void 0;
  this.wsClient = void 0;
  this.client = void 0;
  this.debugMode = void 0;

  this.productInventoryItems = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(nacelleEntryIds) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.client) {
                _context.next = 2;
                break;
              }

              throw new Error('No wsClient');

            case 2:
              _context.next = 4;
              return _this.client.query(productInventoryQuery, {
                filter: {
                  nacelleEntryIds: nacelleEntryIds
                }
              }).toPromise();

            case 4:
              return _context.abrupt("return", _context.sent);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  this.productVariantInventoryItems = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(nacelleEntryIds) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.wsClient) {
                _context2.next = 2;
                break;
              }

              throw new Error('No wsClient');

            case 2:
              _context2.next = 4;
              return _this.client.query(productVariantInventoryQuery, {
                filter: {
                  nacelleEntryIds: nacelleEntryIds
                }
              }).toPromise();

            case 4:
              return _context2.abrupt("return", _context2.sent);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.subscribeToProductUpdate = function (observable, nacelleEntryIds) {
    if (!_this.wsClient) {
      throw new Error('No wsClient');
    }

    try {
      var _pipe = pipe(_this.wsClient.subscription(productSubscription, {
        productInventoryUpdatedFilter: {
          nacelleEntryIds: nacelleEntryIds
        }
      }), subscribe(function (result) {
        if (result.error) {
          observable.onError(result);
        } else {
          observable.onNext(result);
        }
      })),
          unsubscribe = _pipe.unsubscribe;

      return unsubscribe;
    } catch (err) {
      observable.onError(err); // eslint-disable-next-line @typescript-eslint/no-empty-function

      return function () {};
    }
  };

  this.subscribeToProductVariantUpdate = function (observable, nacelleEntryIds) {
    if (!_this.wsClient) {
      throw new Error('No wsClient');
    }

    try {
      var _pipe2 = pipe(_this.wsClient.subscription(productVariantSubscription, {
        variantInventoryUpdatedFilter: {
          nacelleEntryIds: nacelleEntryIds
        }
      }), subscribe(function (result) {
        if (result.error) {
          observable.onError(result);
        } else {
          observable.onNext(result);
        }
      })),
          unsubscribe = _pipe2.unsubscribe;

      return unsubscribe;
    } catch (err) {
      observable.onError(err); // eslint-disable-next-line @typescript-eslint/no-empty-function

      return function () {};
    }
  };

  this.endpoint = params.endpoint;
  this.token = params.token;
  this.debugMode = params.debugMode || false;

  if (this.debugMode) {
    console.info('credentials:', {
      endpoint: this.endpoint,
      token: this.token
    });
  }

  var headers = {
    'x-nacelle-tether-access-token': this.token
  };
  var subscriptionClient = createClient({
    url: this.endpoint,
    connectionParams: headers,
    isFatalConnectionProblem: function isFatalConnectionProblem(errOrCloseEvent) {
      var typeObj = errOrCloseEvent;

      if (typeObj.code === 4403) {
        console.error('Websocket server rejecting auth, check headers for correct x-nacelle-tether-access-token');
        return true;
      }

      return false;
    }
  });
  this.client = params.client || createClient$1({
    url: convertWsToHttp(this.endpoint)
  });
  this.wsClient = params.wsClient || createClient$1({
    url: this.endpoint,
    exchanges: [].concat(defaultExchanges, [subscriptionExchange({
      forwardSubscription: function forwardSubscription(operation) {
        return {
          subscribe: function subscribe(sink) {
            var dispose = subscriptionClient.subscribe(operation, sink);
            return {
              unsubscribe: dispose
            };
          }
        };
      }
    })])
  });
};

function Storefront(params) {
  if (typeof params.token === 'undefined' || params.token.length === 0) {
    throw new Error('Nacelle space token is required.');
  }

  if (typeof params.storefrontEndpoint === 'undefined' || params.storefrontEndpoint.length === 0) {
    throw new Error('Nacelle endpoint is required');
  }

  var locale = params.locale || 'en-US';
  var debugMode = typeof params.debugMode !== 'undefined' ? params.debugMode : false;

  if (debugMode) {
    console.info("\uD83D\uDE4C  Storefront Debug Mode Unlocked! \uD83D\uDE4C");
  }

  var connector = params.connector || new StorefrontConnector({
    token: params.token,
    previewToken: params.previewToken,
    endpoint: params.storefrontEndpoint,
    locale: locale,
    debugMode: debugMode
  });
  var subscriptionConnector = undefined;

  if (params.subscriptionToken && params.subscriptionEndpoint && typeof window !== 'undefined') {
    subscriptionConnector = new SubscriptionConnector({
      token: params.subscriptionToken || '',
      endpoint: params.subscriptionEndpoint || '',
      debugMode: debugMode
    });
  }

  function initializeSubscriptionConnector() {
    if (!subscriptionConnector && params.subscriptionToken && params.subscriptionEndpoint && typeof window !== 'undefined') {
      subscriptionConnector = new SubscriptionConnector({
        token: params.subscriptionToken || '',
        endpoint: params.subscriptionEndpoint || '',
        debugMode: debugMode
      });
    }
  }

  var currencyCode = params.currencyCode || 'USD';
  var onDataError = params.onDataError || null;
  var afterSubscriptions = [];

  function applyAfter(_x, _x2) {
    return _applyAfter.apply(this, arguments);
  }

  function _applyAfter() {
    _applyAfter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(method, responseObj) {
      var response, subs, _iterator, _step, sub;

      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              response = responseObj;
              subs = afterSubscriptions.filter(function (sub) {
                return sub.method === method;
              });
              _iterator = _createForOfIteratorHelperLoose(subs);

            case 3:
              if ((_step = _iterator()).done) {
                _context12.next = 10;
                break;
              }

              sub = _step.value;
              _context12.next = 7;
              return sub.callback(response);

            case 7:
              response = _context12.sent;

            case 8:
              _context12.next = 3;
              break;

            case 10:
              return _context12.abrupt("return", response);

            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));
    return _applyAfter.apply(this, arguments);
  }

  return {
    getConfig: function getConfig() {
      return {
        token: connector.token,
        storefrontEndpoint: connector.endpoint,
        previewToken: connector.previewToken,
        locale: locale,
        currencyCode: currencyCode,
        afterSubscriptions: afterSubscriptions
      };
    },
    products: function () {
      var _products = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(productsParams) {
        var _products2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return connector.products(productsParams);

              case 3:
                _products2 = _context.sent;
                return _context.abrupt("return", applyAfter('products', _products2));

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                if (!onDataError) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", onDataError({
                  method: 'products',
                  params: productsParams || null,
                  error: _context.t0
                }));

              case 11:
                throw _context.t0;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      function products(_x3) {
        return _products.apply(this, arguments);
      }

      return products;
    }(),
    productCollections: function () {
      var _productCollections = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(productCollectionsParams) {
        var _productCollections2;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.info('storefront client, productCollections');
                _context2.prev = 1;
                _context2.next = 4;
                return connector.productCollections(productCollectionsParams);

              case 4:
                _productCollections2 = _context2.sent;
                return _context2.abrupt("return", applyAfter('productCollections', _productCollections2));

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                if (!onDataError) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt("return", onDataError({
                  method: 'productCollections',
                  params: productCollectionsParams || null,
                  error: _context2.t0
                }));

              case 12:
                throw _context2.t0;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 8]]);
      }));

      function productCollections(_x4) {
        return _productCollections.apply(this, arguments);
      }

      return productCollections;
    }(),
    productCollectionEntries: function () {
      var _productCollectionEntries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(collectionEntriesParams) {
        var products;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.info('storefront client, productCollectionEntries');
                _context3.prev = 1;
                _context3.next = 4;
                return connector.productCollectionEntries(collectionEntriesParams);

              case 4:
                products = _context3.sent;
                return _context3.abrupt("return", applyAfter('productCollectionEntries', products));

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);

                if (!onDataError) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return", onDataError({
                  method: 'productCollectionEntries',
                  params: collectionEntriesParams || null,
                  error: _context3.t0
                }));

              case 12:
                throw _context3.t0;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 8]]);
      }));

      function productCollectionEntries(_x5) {
        return _productCollectionEntries.apply(this, arguments);
      }

      return productCollectionEntries;
    }(),
    contentCollectionEntries: function () {
      var _contentCollectionEntries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(collectionEntriesParams) {
        var entries;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.info('storefront client, contentCollectionEntries');
                _context4.prev = 1;
                _context4.next = 4;
                return connector.contentCollectionEntries(collectionEntriesParams);

              case 4:
                entries = _context4.sent;
                return _context4.abrupt("return", applyAfter('contentCollectionEntries', entries));

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);

                if (!onDataError) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt("return", onDataError({
                  method: 'contentCollectionEntries',
                  params: collectionEntriesParams || null,
                  error: _context4.t0
                }));

              case 12:
                throw _context4.t0;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 8]]);
      }));

      function contentCollectionEntries(_x6) {
        return _contentCollectionEntries.apply(this, arguments);
      }

      return contentCollectionEntries;
    }(),
    content: function () {
      var _content = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(contentParams) {
        var _content2;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return connector.content(contentParams);

              case 3:
                _content2 = _context5.sent;
                return _context5.abrupt("return", applyAfter('content', _content2));

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);

                if (!onDataError) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return", onDataError({
                  method: 'content',
                  params: contentParams || null,
                  error: _context5.t0
                }));

              case 11:
                throw _context5.t0;

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 7]]);
      }));

      function content(_x7) {
        return _content.apply(this, arguments);
      }

      return content;
    }(),
    contentCollections: function () {
      var _contentCollections = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(contentCollectionsParams) {
        var _contentCollections2;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return connector.contentCollections(contentCollectionsParams);

              case 3:
                _contentCollections2 = _context6.sent;
                return _context6.abrupt("return", applyAfter('contentCollections', _contentCollections2));

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);

                if (!onDataError) {
                  _context6.next = 11;
                  break;
                }

                return _context6.abrupt("return", onDataError({
                  method: 'contentCollections',
                  params: contentCollectionsParams || null,
                  error: _context6.t0
                }));

              case 11:
                throw _context6.t0;

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 7]]);
      }));

      function contentCollections(_x8) {
        return _contentCollections.apply(this, arguments);
      }

      return contentCollections;
    }(),
    productInventoryItems: function () {
      var _productInventoryItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(nacelleEntryIds) {
        var _subscriptionConnecto;

        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                initializeSubscriptionConnector();

                if (subscriptionConnector) {
                  _context7.next = 4;
                  break;
                }

                throw Error(MISSING_SUB_PARAM_MSG);

              case 4:
                _context7.next = 6;
                return (_subscriptionConnecto = subscriptionConnector) == null ? void 0 : _subscriptionConnecto.productInventoryItems(nacelleEntryIds);

              case 6:
                return _context7.abrupt("return", _context7.sent);

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](0);

                if (!onDataError) {
                  _context7.next = 13;
                  break;
                }

                return _context7.abrupt("return", onDataError({
                  method: 'productInventoryItems',
                  params: {
                    nacelleEntryIds: nacelleEntryIds
                  } || null,
                  error: _context7.t0
                }));

              case 13:
                throw _context7.t0;

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 9]]);
      }));

      function productInventoryItems(_x9) {
        return _productInventoryItems.apply(this, arguments);
      }

      return productInventoryItems;
    }(),
    productVariantInventoryItems: function () {
      var _productVariantInventoryItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(nacelleEntryIds) {
        var _subscriptionConnecto2;

        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                initializeSubscriptionConnector();

                if (subscriptionConnector) {
                  _context8.next = 4;
                  break;
                }

                throw Error(MISSING_SUB_PARAM_MSG);

              case 4:
                _context8.next = 6;
                return (_subscriptionConnecto2 = subscriptionConnector) == null ? void 0 : _subscriptionConnecto2.productVariantInventoryItems(nacelleEntryIds);

              case 6:
                return _context8.abrupt("return", _context8.sent);

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](0);

                if (!onDataError) {
                  _context8.next = 13;
                  break;
                }

                return _context8.abrupt("return", onDataError({
                  method: 'productVariantInventoryItems',
                  params: {
                    nacelleEntryIds: nacelleEntryIds
                  } || null,
                  error: _context8.t0
                }));

              case 13:
                throw _context8.t0;

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 9]]);
      }));

      function productVariantInventoryItems(_x10) {
        return _productVariantInventoryItems.apply(this, arguments);
      }

      return productVariantInventoryItems;
    }(),
    productSubscription: function productSubscription(observable, nacelleEntryIds) {
      var _subscriptionConnecto3;

      if (typeof window === 'undefined') {
        var msg = 'productSubscription can only be called in a browser environment.';
        throw Error(msg);
      }

      initializeSubscriptionConnector();

      if (!subscriptionConnector) {
        throw Error(MISSING_SUB_PARAM_MSG);
      }

      return (_subscriptionConnecto3 = subscriptionConnector) == null ? void 0 : _subscriptionConnecto3.subscribeToProductUpdate(observable, nacelleEntryIds);
    },
    productVariantSubscription: function productVariantSubscription(observable, nacelleEntryIds) {
      var _subscriptionConnecto4;

      if (typeof window === 'undefined') {
        var msg = 'productVariantSubscription can only be called in a browser environment.';
        throw Error(msg);
      }

      initializeSubscriptionConnector();

      if (!subscriptionConnector) {
        throw Error(MISSING_SUB_PARAM_MSG);
      }

      return (_subscriptionConnecto4 = subscriptionConnector) == null ? void 0 : _subscriptionConnecto4.subscribeToProductVariantUpdate(observable, nacelleEntryIds);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    query: function () {
      var _query = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(queryParams) {
        var result;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return connector.query(queryParams);

              case 3:
                result = _context9.sent;
                return _context9.abrupt("return", applyAfter('query', result));

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9["catch"](0);

                if (!onDataError) {
                  _context9.next = 11;
                  break;
                }

                return _context9.abrupt("return", onDataError({
                  method: 'query',
                  params: queryParams,
                  error: _context9.t0
                }));

              case 11:
                throw _context9.t0;

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[0, 7]]);
      }));

      function query(_x11) {
        return _query.apply(this, arguments);
      }

      return query;
    }(),
    navigation: function () {
      var _navigation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(navigationParams) {
        var _navigation2;

        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return connector.navigation(navigationParams);

              case 3:
                _navigation2 = _context10.sent;
                return _context10.abrupt("return", applyAfter('navigation', _navigation2));

              case 7:
                _context10.prev = 7;
                _context10.t0 = _context10["catch"](0);

                if (!onDataError) {
                  _context10.next = 11;
                  break;
                }

                return _context10.abrupt("return", onDataError({
                  method: 'navigation',
                  params: navigationParams || null,
                  error: _context10.t0
                }));

              case 11:
                throw _context10.t0;

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 7]]);
      }));

      function navigation(_x12) {
        return _navigation.apply(this, arguments);
      }

      return navigation;
    }(),
    setConfig: function setConfig(setConfigParams) {
      return connector.setConfig(setConfigParams);
    },
    spaceProperties: function () {
      var _spaceProperties = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _spaceProperties2;

        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return connector.spaceProperties();

              case 3:
                _spaceProperties2 = _context11.sent;
                return _context11.abrupt("return", applyAfter('spaceProperties', _spaceProperties2));

              case 7:
                _context11.prev = 7;
                _context11.t0 = _context11["catch"](0);

                if (!onDataError) {
                  _context11.next = 11;
                  break;
                }

                return _context11.abrupt("return", onDataError({
                  method: 'spaceProperties',
                  params: null,
                  error: _context11.t0
                }));

              case 11:
                throw _context11.t0;

              case 12:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[0, 7]]);
      }));

      function spaceProperties() {
        return _spaceProperties.apply(this, arguments);
      }

      return spaceProperties;
    }(),
    after: function after(method, callback) {
      afterSubscriptions.push({
        method: method,
        callback: callback
      });
    }
  };
}

export { ChunkFilterName, ContentSearchFields, DataSourceName, EntryType, Locales, NavigationPropertyType, ProductCollectionSearchFields, ProductCollectionSortOrder, ProductSearchFields, Storefront, Storefront as default };